import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SensorHistoryToolbarComponent } from './sensor-history-toolbar.component';
import {
  DxDateBoxModule,
  DxLoadPanelModule,
  DxSelectBoxModule,
  DxToolbarModule,
  DxValidationGroupModule,
  DxValidatorModule
} from 'devextreme-angular';



@NgModule({
  declarations: [SensorHistoryToolbarComponent],
  imports: [
    CommonModule,
    DxLoadPanelModule,
    DxValidationGroupModule,
    DxToolbarModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxValidatorModule
  ],
  exports: [SensorHistoryToolbarComponent]
})
export class SensorHistoryToolbarModule { }
